export default "__VITE_ASSET__70843c79__"